module.exports = __webpack_public_path__ + "static/media/internet.6fd19fc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/internet.jpg
// module id = 345
// module chunks = 0